import { defineComponent } from 'vue';
import { translator } from '~/zf/frontend/common/mixins';
import LocalizationService from '~/zf/frontend/common/localization/LocalizationService';
import MomentFormat from '~/zf/frontend/common/moment/MomentFormat';
export default defineComponent({
    name: 'StartDate',
    compatConfig: {
        MODE: 3,
    },
    mixins: [translator],
    props: {
        startDate: {
            type: Date,
            required: true,
        },
    },
    computed: {
        formattedStartDate() {
            return LocalizationService.localizeDateTimeFormat(this.startDate, MomentFormat.LOCALE_SHORT_TIME);
        },
    },
});
